<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo /> -->
        <h2 class="brand-text text-primary ml-1">
          E-Cuti
        </h2>
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            Welcome to E-Cuti! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Please sign-in to your account and start the process
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginForm" #default="{invalid}">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- email -->
              <b-form-group
                label="Email"
                label-for="login-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="username"
                    :state="errors.length > 0 ? false:null"
                    name="login-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <b-link :to="{name:'auth-forgot-password-v2'}">
                    <small>Forgot Password?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
                @click="login()"
                
              >
                Sign in
              </b-button>
            </b-form>
          </validation-observer>

          <!-- <b-card-text class="text-center mt-2">
            <span>New on our platform? </span>
            <b-link :to="{name:'page-auth-register-v2'}">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text> -->

          <!-- divider -->
          <div class="divider my-2">
            <div class="divider-text">
              or
            </div>
          </div>

          <b-card-text class="text-center mt-2">
            <a href="https://sso.ui.ac.id/cas/login?service=https%3A%2F%2Fbackend-cuti.portal-psikoui.com%2Fapi%2Fv1%2Fcas%2Flogin">
              &nbsp;Login SSO
            </a>
          </b-card-text>

          <!-- social buttons -->
          <!-- <div class="auth-footer-btn d-flex justify-content-center">
            <b-button
              variant="facebook"
              href="javascript:void(0)"
            >
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button
              variant="twitter"
              href="javascript:void(0)"
            >
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button
              variant="google"
              href="javascript:void(0)"
            >
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button
              variant="github"
              href="javascript:void(0)"
            >
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import router from '@/router'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import {
  Authlogin,
  setToken,
  setRefreshToken,
} from '@/connection-api/authentication'
import {
  resetAkun,
  getTokenSso,
} from '@/connection-api/master'

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      // validation rulesimport store from '@/store/index'
      showLogin: 0,
      loading: 0,
      loadingShow: false,
      reset: {},
      username: '',
      password: '',
      status: '',
      login_sebagai: null,
      // validation rules
      required,
      email,
      // sideImg: require('@/assets/images/logo/logo.png'),
      loginSebagaiOption: {
        selected: 'id',
        options: [
          { value: null, title: '--Pilih Login Sebagai --' },
          { value: 'mahasiswa', title: 'Mahasiswa' },
          { value: 'penguji', title: 'Penguji' },
          { value: 'pembimbing', title: 'Pembimbing' },
          
        ],
      },
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    showLoginF() {
      if(this.showLogin == 1)
      {
        this.showLogin = 0
      } else {
        this.showLogin = 1
      }
    },
    simpanResetAkun()
    {
      this.loadingShow = true
      resetAkun(this.reset)
      .then(response => {
      if (response.data.success == true) {
        this.loadingShow = false
       this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Reset Akun`,
            icon: 'CoffeeIcon',
            variant: 'success',
            text: 'Anda telah berhasil reset akun Aplikasi E-Cuti. Silahkan login menggunakan kredensial baru anda.',
          },
        })
        this.$bvModal.hide('bv-modal-reset-user')
      } else {
        this.loadingShow = false
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: `Reset Akun`,
            icon: 'CoffeeIcon',
            variant: 'danger',
            text: response.data.message,
          },
        })
        // this.$bvModal.hide('bv-modal-reset-user')
      }
      })
      .catch(error => console.log(error));
    },
    login() {
      this.loading = 1
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          Authlogin({
            email: this.username,
            password: this.password,
            application_token: this.applicationToken,
            query: router.currentRoute.query,
            token_firebase: localStorage.getItem('tokenFirebase'),
            login_sebagai: this.login_sebagai,
          })
            .then(response => {
              if (response.data.error) {
                this.loading = 0
                this.$swal({
                  title: 'Gagal!',
                  html: `${response.data.message}`,
                  icon: 'error',
                  customClass: {
                    confirmButton: 'btn btn-primary',
                  },
                  buttonsStyling: false,
                })
              } else {
                this.loading = 0
                if(response.data.reset == true)
                {
                  this.$bvModal.show('bv-modal-reset-user')
                  this.reset.token = response.data.token
                }

                const { member, urlCallback } = response.data.data
                setToken(response.data.data.accessToken)
                setRefreshToken(response.data.data.refreshToken)

                /// /////// TEMPORARY ACL SIMULATION ////////////////

                // baca value userData.roles
                // value-nya mungkin bisa  array of string atau hanya string
                // jadi perlu check if array
                // let userRole = ''
                // if (Array.isArray(member.roles)) {
                //   // ambil item pertama
                //   const test = member.roles[0]
                //   userRole = test
                // } else {
                //   userRole = member.roles
                // }

                localStorage.setItem('userData', JSON.stringify(member))
                this.$ability.update(member.ability)
                if (urlCallback === '') {
                  this.$router.push('/dashboard/analytics')
                    .then(() => {
                      this.$toast({
                        component: ToastificationContent,
                        position: 'top-right',
                        props: {
                          title: `Selamat Datang ${member.fullName || member.username}`,
                          icon: 'CoffeeIcon',
                          variant: 'success',
                          text: 'Anda telah berhasil masuk Aplikasi E-Cuti. Sekarang Anda bisa mulai menjelajah!',
                        },
                      })
                    })
                } else {
                  localStorage.setItem('urlCallback', urlCallback)
                  window.location.href = urlCallback
                }
              }
            })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
